/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function cmd_${NAME}(data) {
    /****cmd_${NAME}****/
}
`,
    });

    blocks.push({
        location: 'ON_SIMULATOR_RUN_COMMAND',
        blockType: BlockType.CODE,
        template: `
        case '${NAME}':
            cmd_${NAME}(data);
            break;
        `,
    });

    return blocks;
};
